import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle } from 'lucide-react';
const CHECKOUT_URL = 'https://research-methods-teacher-ready.impultienda.ar/checkout';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-113" data-mp="9l341bdfia3g">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-114" data-mp="4mrxb9ifkfpg" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-115" data-mp="1274kvg6l3030">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-116" data-mp="x8b9btauxj5h">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-117" data-mp="nbomx02vuk1c">
            📚 Research Methods Teacher Ready™
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-118" data-mp="3j7zgtn69y0is">
            Solve an Entire Year of Research Methods Lessons{' '}
            <span className="text-gold-gradient" data-id="element-119" data-mp="39alaige2es47">in Just 5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[300px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-120" data-mp="3e8wkqs89v4my">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-121" data-mp="35aklk1tcayiw" />
          <img src="https://cdn.magicpatterns.com/uploads/9oZiWNnYJgf6dWwvtpWar9/Diseno_sin_titulo_(46).png" alt="Research Methods Teacher Ready — complete 6-in-1 teaching system" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-122" data-mp="2qlogmdmky1mi" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-123" data-mp="2ljz6d076lrzh">
          <p className="text-sm sm:text-lg md:text-xl leading-snug max-w-2xl mx-auto mb-2 sm:mb-3 font-semibold text-white" data-id="element-124" data-mp="na0ab23m59fr">
            Research Methods Teacher Ready™ — The Complete 6-in-1 Teaching System
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-125" data-mp="dbastafmpr01">
            The complete professional teaching library for high school and introductory college Research Methods — ready to use starting today.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-126" data-mp="110wohnwslo3a">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={() => trackCheckout()} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-127" data-mp="x1w6g7m52phc">
              🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-128" data-mp="1x784pmxv7ptl">
            {['Complete Teaching Library', '5 Strategic Resources', 'Immediate Access'].map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-129" data-mp="2686d0hfc6jhz">
                <CheckCircle size={14} className="text-gold" data-id="element-130" data-mp="2b2akr2wfevk4" />
                <span data-id="element-131" data-mp="2g0ls96z90tz6">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}
function trackCheckout() {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'InitiateCheckout', {
      content_name: 'Research Methods Teacher Ready Complete System',
      value: 27,
      currency: 'USD'
    });
  }
}